module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aLbuO"))).then(() => parcelRequire('hEqeo'));